import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { CalculationMethod } from "../../common/calculation-method";
import { AddressDTO, InventoryDocumentBuyerDTO, InventoryDocumentClientDTO } from "../../document/dto/document-client.dto";
import { DocumentExchangeRateDTO } from "../../document/dto/document-exchange-rate.dto";
import { DocumentVatTableDTO } from "../../document/dto/document-vat-table.dto";
import { InventoryDocumentKind } from "../inventory-document-kind";
import { InventoryRelationshipCreationMethod } from "../inventory-relationship-creation-method";
import { InventoryGetDocumentItemDTO, InventoryUpdateDocumentItemDTO } from "./inventory-document-item.dto";

export class InventoryGoodsIssueDocumentDTO {
	@Type(() => InventoryDocumentBuyerDTO) public buyer: InventoryDocumentBuyerDTO | null;
	public calculationMethod: CalculationMethod.Gross | CalculationMethod.Net;
	@Type(() => InventoryDocumentClientDTO) public client: InventoryDocumentClientDTO | null;
	public communityTransactionId: number;
	public currencyId: number;
	@Type(() => AddressDTO) public deliveryAddress: AddressDTO | null;
	public documentNumber: string;
	@Type(() => DocumentExchangeRateDTO) public exchangeRate: DocumentExchangeRateDTO | null;
	public id: number;
	@Transform(transformDTODate, { toClassOnly: true }) public issueDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public goodsIssueDate: Date;
	public issuer: string;
	public kind: InventoryDocumentKind;
	public numberingId?: number;
	public recipient: string;
	public note: string | null;
	public transactionLocation: string;
	public wstoShipmentCountryId?: number;
	public wstoConsumerCountryId?: number | null;
	public wstoAdditionalInformation: string;
	public duplicatePreventionId: string;
	public version: string;
	public inventoryId: number;
	public relatedCommercialDocuments: { id: number, version: string }[];
	public grossValue: number;
	public netValue: number;

	//adjustments
	public adjustedDocumentVersion?: string;
	public adjustedDocumentId?: number;
}

export class InventoryGetGoodsIssueDocumentDTO extends InventoryGoodsIssueDocumentDTO {
	@Type(() => InventoryGetDocumentItemDTO) public items: InventoryGetDocumentItemDTO[];
	@Type(() => DocumentVatTableDTO) public vatTable: DocumentVatTableDTO;
	public issuedByVatPayer: boolean;
	public baseCurrencyGrossValue: number;
	public baseCurrencyNetValue: number;
}

export class InventoryUpdateGoodsIssueDocumentDTO extends InventoryGoodsIssueDocumentDTO {
	@Type(() => InventoryUpdateDocumentItemDTO) public items: InventoryUpdateDocumentItemDTO[];
	public creationMethod: InventoryRelationshipCreationMethod;
}

